import { render } from "./PaymentMethodList.vue?vue&type=template&id=73559974&scoped=true"
import script from "./PaymentMethodList.vue?vue&type=script&lang=js"
export * from "./PaymentMethodList.vue?vue&type=script&lang=js"

import "./PaymentMethodList.vue?vue&type=style&index=0&id=73559974&lang=scss&scoped=true"
import "./PaymentMethodList.vue?vue&type=style&index=1&id=73559974&lang=scss"

import exportComponent from "/Users/mac/Documents/Tranzak/Frontend/tzpay/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73559974"]])

export default __exports__